import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { QuestionResult } from "models";

export const useQuestionResultMutation = () =>
  useTypedMutation<QuestionResult, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/checks/question_result/update", payload);
    },
    onSuccess: payload => {
      const checks = typedQueryClient.getQueryData(AppointmentDetailsKeys.checks);
      if (!checks?.length) return;

      const checkIdx = checks.findIndex(check => check.question_items?.some(question => question.id === payload.id));
      if (checkIdx < 0 || !checks[checkIdx].question_items?.length) return;

      const questions = checks[checkIdx].question_items;
      const questionIdx = questions.findIndex(question => question.id === payload.id);
      if (questionIdx < 0) return;

      typedQueryClient.setQueryData(
        AppointmentDetailsKeys.checks,
        checks.with(checkIdx, { ...checks[checkIdx], question_items: questions.with(questionIdx, { ...questions[questionIdx], ...payload }) })
      );
    }
  });
